/**TODAS LAS VARIABLES GLOBALES QUE SE UTILIZAN PARA LA AUTENTICACIÓN */

export const API_AUTH = "https://api.talleravellaneda.com.ar/auth.php";
//login
//logout
//loged

export const API_USER = "hhtps://api.talleravellaneda.com.ar/users.php";
//lista-usuarios
//ver-usuario
//nuevo-usuario
//modificar-usuario
//eliminar-usuario